import { render } from "./BtnMobile.vue?vue&type=template&id=54a9afb8&scoped=true"
const script = {}

import "./BtnMobile.vue?vue&type=style&index=0&id=54a9afb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54a9afb8"]])

export default __exports__